<template>
  <div
    class="flex min-h-[calc(100vh-120px)] flex-col justify-between"
    :class="{
      'mb-40': !user,
      'h-0 overflow-hidden': uiStore.vaFilterNavDrawerOpen,
    }"
  >
    <VaFilterMobileWrapper @setNavDrawerOpen="toggleNavDrawer" />
    <div class="my-0 mr-auto w-full text-center">
      <div
        v-if="user && checkoutStore.matchingCriteria"
        class="bg-vgocean z-10 flex flex-col justify-between px-10 py-3 text-center md:flex-row"
      >
        <h1 class="text-center text-lg font-bold text-white md:text-left">
          Add candidates to your talent pool
        </h1>
        <button
          v-if="!uiStore.mobile"
          class="bg-vgteal-200 text-vgocean rounded-xl p-2 px-5 text-sm font-semibold"
          @click="goToCheckoutConfirmation"
        >
          {{
            !uiStore.mobile && checkoutStore.matchingCriteria.cart?.length == 0
              ? 'PICK CANDIDATES LATER & PROCEED TO CHECKOUT'
              : 'PROCEED TO CHECKOUT'
          }}
        </button>
      </div>

      <div
        class="mx-auto mb-4 flex max-w-7xl md:my-5"
        :class="{ 'mb-0 flex flex-col ': uiStore.mobile }"
      >
        <div
          v-if="user && checkoutStore.matchingCriteria"
          :class="{ 'w-[500px]': !uiStore.mobile }"
          class="md:mr-4"
        >
          <div
            class="flex flex-col gap-4 bg-white p-4 md:mx-4 md:mb-3 md:rounded-t-2xl"
          >
            <h2 class="mb-0 text-left text-2xl font-bold text-black">
              Your roles
            </h2>
            <p class="m-0 text-left text-sm">
              You’re viewing prospective candidates who are skilled in the
              role(s), skills and tools you selected. Use the selection boxes
              and filters to narrow or broaden your search.
            </p>
            <div class="flex flex-row items-center justify-between">
              <v-checkbox
                true-icon="mdi-checkbox-marked-outline"
                class="text-black"
                on-icon:color="black"
                :model-value="shouldCheckAll"
                :disabled="checkoutStore.matchingCriteria.rids?.length === 1"
                hide-details
                @update:model-value="selectAllRoles"
              >
                <template #label
                  ><p
                    class="mb-0 ml-5 text-xs font-bold"
                    :class="
                      selectedRolesCheckbox.includes(-1)
                        ? 'text-vgsoftblue'
                        : 'text-vgstone'
                    "
                  >
                    VIEW ALL
                  </p>
                </template>
              </v-checkbox>
              <div class="flex flex-row items-center justify-end gap-2">
                <p class="text-vgocean mb-0 text-xs font-bold uppercase">
                  hours
                </p>
                <button
                  :disabled="selectedRolesWithHours.length === 0"
                  @click="editHours = true"
                >
                  <fa-icon
                    :class="[
                      'bg-vgocean-100 rounded-full p-2',
                      selectedRolesWithHours.length === 0
                        ? 'text-vgstone'
                        : 'text-vgocean',
                    ]"
                    icon="fa-regular fa-pencil"
                  />
                </button>
              </div>
            </div>
            <div
              v-for="role in selectedRolesWithHours"
              :key="role.id"
              class="-mt-5 flex flex-row items-center justify-between"
            >
              <v-checkbox
                v-model="selectedRolesCheckbox"
                :value="role.id"
                true-icon="mdi-checkbox-marked-outline"
                class="flex text-black"
                on-icon:color="black"
                hide-details
              >
                <template #label
                  ><v-chip
                    class="ml-3 text-sm font-semibold"
                    :class="
                      selectedRolesCheckbox.includes(role.id)
                        ? 'bg-vgsoftblue'
                        : 'border-vgstone text-vgstone'
                    "
                    :variant="
                      !selectedRolesCheckbox.includes(role.id)
                        ? 'outlined'
                        : 'tonal'
                    "
                  >
                    {{ role.value }}
                    <span
                      v-if="checkoutStore.assistantsObj.roleCount"
                      class="pl-2"
                      >({{
                        checkoutStore.assistantsObj.roleCount[role.id] || 0
                      }})</span
                    >
                  </v-chip>
                </template>
              </v-checkbox>
              <div class="flex flex-row items-center justify-end gap-2">
                <p
                  :class="[
                    'bg-vgsilver-200 mb-0 rounded-sm px-2 py-1',
                    selectedRolesCheckbox.includes(role.id)
                      ? 'text-black'
                      : 'text-vgstone',
                  ]"
                >
                  {{
                    role.hours ===
                    checkoutHoursItems.find((item) => item.title === '100+')
                      .value
                      ? '100+'
                      : role.hours
                  }}
                </p>
                <button>
                  <fa-icon
                    icon="fa-regular fa-trash-can"
                    :class="[
                      selectedRolesCheckbox.includes(role.id)
                        ? 'text-vgocean'
                        : 'text-vgstone',
                    ]"
                    @click="removeRole(role)"
                  />
                </button>
              </div>
            </div>
            <v-checkbox
              true-icon="mdi-checkbox-blank-outline"
              class="-mt-2 text-black"
              hide-details
              @click="
                currentAddRoleIndex = 0;
                checkoutStore.setIsInModal(true);
              "
            >
              <template #label
                ><v-chip
                  class="bg-vgocean-100 text-vgocean ml-3 text-sm font-semibold"
                >
                  <fa-icon
                    icon="fa-regular fa-plus"
                    class="text-vgocean mr-3"
                  />
                  <p class="text-vgocean mb-0 pr-5 text-xs font-bold uppercase">
                    add roles
                  </p>
                </v-chip>
              </template>
            </v-checkbox>
            <p class="text-right text-sm font-bold">
              Selected hours: {{ totalHours }}
            </p>
            <div class="flex justify-between">
              <HoursEditor
                :edit-hours="editHours"
                @hoursChanged="hoursChanged"
                @closeEditHours="editHours = false"
              />
            </div>
          </div>
          <div
            v-if="uiStore.mobile"
            :class="`${
              uiStore.vaFilterNavDrawerOpen ? 'z-0' : 'z-50'
            } p-2 pb-0 md:mb-3 text-left bg-white border-b-2 md:shadow-md`"
            role="button"
            @click="toggleNavDrawer()"
          >
            <p class="text-vgocean text-center">
              <fa-icon
                icon="fa-regular fa-bars-filter"
                class="translate-y-1 text-lg"
              />
              <span class="text-xs font-bold uppercase"> filter result</span>
            </p>
          </div>
          <VaSearchFilters
            v-else
            :class="{ 'mx-4 ': !uiStore.mobile }"
            @hoursChanged="checkVAsInCartForNewHours"
          >
          </VaSearchFilters>
          <div v-if="!uiStore.mobile" class="mx-4 mt-5 text-left">
            <h3 class="mb-1 text-xl">Can’t decide? We’re here to help!</h3>
            <p class="text-vgocean text-sm">
              Book a call with our Solutions team and they’ll help you choose
              the best assistant(s) for your needs.
            </p>
            <vg-btn
              v-if="user"
              class="rounded-lg px-10"
              @click="helpMeDecideModal = true"
              ><span class="px-5 text-sm uppercase"
                >Help me decide</span
              ></vg-btn
            >
          </div>
        </div>

        <div
          class="my-0 w-full max-w-7xl text-center"
          :class="{ 'mx-auto': !user || uiStore.mobile }"
        >
          <div
            v-if="
              (!user && vaProfiles.length !== 0) ||
              (user && checkoutStore.assistantsObj.count > 0)
            "
          >
            <div>
              <h2
                v-if="user"
                class="text-left text-2xl text-black"
                :class="{ 'ml-4 text-center': uiStore.mobile }"
              >
                Results:<span class="mb-1 ml-2 text-base">
                  {{
                    assistants.length > 0
                      ? `(${
                          checkoutStore.assistantPagination.assistantsPage === 1
                            ? assistantsForPagination.length - 1
                            : assistantsForPagination.length
                        }
                of ${assistants.length})`
                      : '(no result)'
                  }}
                </span>
              </h2>
              <div
                v-if="user"
                class="grid justify-items-stretch gap-4 sm:grid-cols-1 md:grid-cols-2 xl:grid-cols-3"
              >
                <div
                  v-for="(assistant, index) in vaProfiles"
                  :key="assistant.name"
                  :class="[
                    'card relative min-w-[160px]  rounded-2xl bg-white p-4 hover:shadow-lg ',
                    isVaProfileAddedToCart(assistant)
                      ? 'border-vgteal border'
                      : '',
                    assistant.isSpecial ? 'bg-vgocean-200' : '',
                    uiStore.mobile
                      ? 'mx-4 '
                      : 'mx-0 flex min-h-[400px] flex-col',
                  ]"
                  @click="showAssistant(assistant)"
                >
                  <div
                    v-if="!assistant.isSpecial"
                    class="flex"
                    :class="{
                      'flex flex-col items-stretch': !uiStore.mobile,
                    }"
                  >
                    <div v-if="!uiStore.mobile">
                      <div class="flex flex-row">
                        <div class="relative pr-7">
                          <v-avatar size="70" class="mb-2 bg-white">
                            <v-img
                              :src="getAvatar(assistant)"
                              lazy-src="/img/profile.png"
                            >
                            </v-img>
                          </v-avatar>
                        </div>
                        <div>
                          <p
                            class="name-cut mb-2 text-left text-base font-bold"
                          >
                            {{ assistant.display_name }}
                          </p>
                          <div
                            class="flex flex-row flex-wrap items-center gap-3"
                          >
                            <p
                              v-if="
                                checkFeatureFlag(
                                  'new-client-checkout-va-rating'
                                )
                              "
                              class="text-vgorange border-vgorange flex rounded-full border-2 px-3 py-1 text-xs font-bold"
                            >
                              <fa-icon
                                class="text-vgorange mr-2"
                                icon="fa-solid fa-star text-xs"
                              />
                              {{
                                Math.round(
                                  ((assistant.va_rating || 0) * 5 +
                                    Number.EPSILON) *
                                    100
                                ) / 100
                              }}
                            </p>
                            <p
                              v-if="
                                checkFeatureFlag(
                                  'new-client-checkout-feedback'
                                ) || assistant.feedback_count > 0
                              "
                              class="text-vgorange text-xs font-semibold underline"
                            >
                              {{ assistant.feedback_count || 0 }} reviews
                            </p>
                          </div>
                        </div>
                      </div>
                      <p class="cut my-2 h-[120px] text-left text-sm">
                        {{ assistant.blurb }}
                      </p>
                      <p class="text-left text-sm font-bold">Roles</p>
                      <div
                        :class="[
                          'grid grid-flow-col place-items-start gap-3',
                          showTwoLine(index)
                            ? assistantFilteredRoles(assistant).length > 2
                              ? 'min-h-[84px] grid-rows-2'
                              : 'min-h-[84px]'
                            : '',
                        ]"
                      >
                        <v-chip
                          v-for="role of assistantFilteredRoles(
                            assistant
                          ).slice(0, 3)"
                          :key="role"
                          class="bg-vgsoftblue vg-truncate-chip mb-1 font-semibold"
                          style="font-size: 10px"
                        >
                          <span class="truncate">{{ role }}</span></v-chip
                        >
                        <v-chip
                          v-if="
                            assistantFilteredRoles(assistant).length - 3 > 0
                          "
                          class="bg-vgsoftblue mb-1 px-3 font-semibold"
                          style="font-size: 10px"
                          >+{{
                            assistantFilteredRoles(assistant).length - 3
                          }}</v-chip
                        >
                      </div>
                      <!-- Should remove false after upgrading to Mysql version 8 -->
                      <div
                        v-if="
                          (assistantFilteredSkills(assistant) || []).length !==
                          0
                        "
                        class="border-vgsilver-200 mt-2 border-t"
                      >
                        <div class="flex justify-between">
                          <p class="mt-2 text-left text-xs font-semibold">
                            <fa-icon icon="fa-light fa-hand-sparkles" />
                            Matching Skills
                          </p>
                          <p
                            class="border-vgsilver-500 mt-2 rounded-sm border px-2"
                            style="font-size: 10px"
                          >
                            {{
                              (assistantFilteredSkills(assistant) || []).length
                            }}
                            of {{ checkoutStore.selectedSkills.length }}
                          </p>
                        </div>
                        <p
                          v-for="skill of (
                            assistantFilteredSkills(assistant) || []
                          ).slice(0, 3)"
                          :key="skill"
                          class="mb-1 truncate text-left font-normal"
                          style="font-size: 10px"
                        >
                          <fa-icon icon="fa-regular fa-check" class="mr-2" />
                          {{ skill }}
                        </p>
                        <p
                          v-if="assistantFilteredSkills(assistant).length > 3"
                          class="text-vgmedturq text-left text-xs font-semibold"
                        >
                          {{ assistantFilteredSkills(assistant).length - 3 }}
                          more....
                        </p>
                      </div>
                      <!-- Should remove false after upgrading to Mysql version 8 -->
                      <div
                        v-if="assistantFilteredTools(assistant).length !== 0"
                      >
                        <div
                          class="border-vgsilver-200 flex justify-between border-t"
                        >
                          <p class="mt-2 text-left text-xs font-semibold">
                            <fa-icon icon="fa-light fa-screwdriver-wrench" />
                            Matching Tools
                          </p>
                          <p
                            class="border-vgsilver-500 mt-2 rounded-sm border px-2"
                            style="font-size: 10px"
                          >
                            {{ assistantFilteredTools(assistant).length }}
                            of {{ checkoutStore.selectedTools.length }}
                          </p>
                        </div>
                        <p
                          v-for="tool of assistantFilteredTools(
                            assistant
                          ).slice(0, 3)"
                          :key="tool"
                          class="mb-1 truncate text-left font-normal"
                          style="font-size: 10px"
                        >
                          <fa-icon icon="fa-regular fa-check" class="mr-2" />
                          {{ tool }}
                        </p>
                        <p
                          v-if="assistantFilteredTools(assistant).length > 3"
                          class="text-vgmedturq text-left text-xs font-semibold"
                        >
                          {{ assistantFilteredTools(assistant).length - 3 }}
                          more....
                        </p>
                      </div>
                    </div>

                    <div class="pb-5">
                      <div v-if="uiStore.mobile" class="h-4">
                        <p
                          v-show="isVaProfileAddedToCart(assistant)"
                          class="text-vgmedturq text-left text-xs font-semibold"
                        >
                          <span>
                            <v-icon size="small" class="mb-1" :color="vgTeal"
                              >mdi-check-circle-outline</v-icon
                            ></span
                          >
                          added
                        </p>
                      </div>
                      <div v-if="uiStore.mobile" class="flex flex-col">
                        <div class="relative">
                          <v-avatar size="112" class="mb-2 bg-white">
                            <v-img
                              :src="getAvatar(assistant)"
                              lazy-src="/img/profile.png"
                            >
                            </v-img>
                          </v-avatar>
                        </div>
                        <div
                          class="z-10 mx-1 -mt-6 flex content-between justify-between rounded-full bg-white p-1 drop-shadow"
                        >
                          <button
                            class="bg-vgteal mr-2 rounded-full p-1"
                            @click="showAssistant(assistant)"
                          >
                            <fa-icon
                              class="bg-vgteal m-1 text-white"
                              icon="fa-regular fa-magnifying-glass"
                            />
                          </button>
                          <button
                            v-if="isVaProfileAddedToCart(assistant)"
                            class="bg-vgteal rounded-full p-1"
                            @click.stop="showRemoveModalAtIndex = index"
                          >
                            <fa-icon
                              class="bg-vgteal m-1 text-white"
                              icon="fa-regular fa-minus-circle"
                            />
                          </button>
                          <button
                            v-else
                            class="bg-vgteal rounded-full p-1"
                            @click.stop="
                              addCandidateOrShowFirstTimeModal(assistant, index)
                            "
                          >
                            <fa-icon
                              class="bg-vgteal m-1 text-white"
                              icon="fa-regular fa-plus-circle"
                            />
                          </button>
                        </div>
                      </div>
                    </div>
                    <div v-if="uiStore.mobile" class="flex flex-col">
                      <p class="name-cut mb-2 self-center text-base font-bold">
                        {{ assistant.display_name }}
                      </p>
                      <div
                        class="grid grid-flow-row justify-items-center"
                        :class="{ 'order-last': uiStore.mobile }"
                      >
                        <v-chip
                          v-for="role of assistantFilteredRoles(assistant)"
                          :key="role"
                          class="bg-vgsoftblue mb-1 truncate"
                        >
                          {{ role }}</v-chip
                        >
                      </div>
                      <p class="cut my-2 h-[9] text-sm">
                        {{ assistant.blurb }}
                      </p>
                    </div>
                  </div>
                  <div v-if="uiStore.mobile && assistant.isSpecial">
                    <div class="flex">
                      <div class="relative">
                        <v-avatar size="100" class="my-2 ml-2">
                          <v-img
                            :src="specialVGUser.avatar"
                            lazy-src="/img/profile.png"
                          />
                          <template #placeholder>
                            <v-row fill-height align-center ma-0>
                              <v-progress-circular
                                indeterminate
                                color="grey-lighten-5"
                              ></v-progress-circular>
                            </v-row>
                          </template>
                        </v-avatar>
                      </div>
                      <div class="ml-4 h-32 text-left">
                        <p class="mb-0 text-xl font-bold">
                          We’re here to help!
                        </p>
                        <p class="text-vgocean text-sm">
                          Book a consult with our team and they will help you
                          choose the best match or your needs!
                        </p>
                      </div>
                    </div>
                    <div class="flex justify-end px-2">
                      <button
                        class="bg-vgocean rounded-3xl px-4 py-1 font-semibold text-white"
                        @click.stop="helpMeDecideModal = true"
                      >
                        Help me decide
                      </button>
                    </div>
                  </div>
                  <div v-if="!uiStore.mobile && assistant.isSpecial">
                    <!-- help me decide -->
                    <div class="relative">
                      <v-avatar size="112" class="my-2 ml-2">
                        <v-img
                          :src="specialVGUser.avatar"
                          lazy-src="/img/profile.png"
                        />
                        <template #placeholder>
                          <v-row fill-height align-center ma-0>
                            <v-progress-circular
                              indeterminate
                              color="grey-lighten-5"
                            ></v-progress-circular>
                          </v-row>
                        </template>
                      </v-avatar>
                    </div>
                    <div>
                      <p class="name-cut mb-2 self-center text-base font-bold">
                        {{ assistant.display_name }}
                      </p>

                      <p class="cut my-2 h-[9] text-sm">
                        {{ assistant.blurb }}
                      </p>
                    </div>
                  </div>
                  <div v-if="!uiStore.mobile">
                    <!-- help me decide -->
                    <div
                      v-if="assistant.isSpecial"
                      class="mt-2 flex justify-center"
                    >
                      <button
                        class="bg-vgocean mt-4 rounded-3xl px-4 py-1 font-semibold uppercase text-white"
                        @click.stop="helpMeDecideModal = true"
                      >
                        help me decide
                      </button>
                    </div>
                    <div
                      v-else-if="isVaProfileAddedToCart(assistant)"
                      class="mt-2"
                    >
                      <button
                        class="bg-vgteal mr-2 h-[30px] w-[30px] rounded-full"
                        @click="showAssistant(assistant)"
                      >
                        <fa-icon
                          class="bg-vgteal text-white"
                          icon="fa-regular fa-magnifying-glass"
                        />
                      </button>

                      <button
                        class="bg-vgteal h-[30px] w-[30px] rounded-full"
                        @click.stop="showRemoveModalAtIndex = index"
                      >
                        <fa-icon
                          class="bg-vgteal text-white"
                          icon="fa-regular fa-minus"
                        />
                      </button>
                    </div>
                    <div v-else class="mt-2 flex justify-center">
                      <button
                        class="outline-icon mr-2 rounded-full"
                        @click="showAssistant(assistant)"
                      >
                        <fa-icon
                          class="text-vgmedturq"
                          icon="fa-regular fa-magnifying-glass"
                        />
                      </button>
                      <button
                        class="outline-icon rounded-full"
                        @click.stop="
                          addCandidateOrShowFirstTimeModal(assistant, index)
                        "
                      >
                        <fa-icon
                          class="text-vgmedturq"
                          icon="fa-regular fa-plus"
                        />
                      </button>
                    </div>
                    <p
                      v-show="
                        isVaProfileAddedToCart(assistant) &&
                        !assistant.isSpecial
                      "
                      class="text-vgmedturq -mt-6 self-center text-left text-xs font-semibold"
                    >
                      <span>
                        <v-icon size="small" class="mb-1" :color="vgTeal"
                          >mdi-check-circle-outline</v-icon
                        ></span
                      >
                      added
                    </p>
                  </div>
                  <div
                    v-show="showRemoveModalAtIndex === index"
                    class="absolute inset-x-0 bottom-0 z-20 h-1/2 rounded-2xl bg-white shadow drop-shadow"
                  >
                    <p
                      class="mx-5 mt-3 text-left text-sm font-bold md:m-7 md:text-center"
                    >
                      Are you sure you want to remove this VA?
                    </p>
                    <div
                      class="mx-5 flex items-center justify-end gap-5 md:flex-col"
                    >
                      <button
                        class="bg-vgteal mb-3 rounded-3xl px-8 py-2 text-sm font-bold text-white"
                        @click.stop="showOrRemoveAssistant(assistant, index)"
                      >
                        Yes
                      </button>
                      <button
                        class="text-vgmedturq text-sm font-semibold"
                        @click.stop="showRemoveModalAtIndex = -1"
                      >
                        cancel
                      </button>
                    </div>
                  </div>
                  <div
                    v-show="showFirstTimeAddModalAtIndex === index"
                    class="absolute inset-x-0 bottom-0 z-20 h-full rounded-2xl bg-white p-5 text-left shadow drop-shadow md:h-2/3 md:min-h-[300px] md:p-0 md:text-center"
                  >
                    <p class="text-sm font-bold md:m-7">
                      Candidate added to your talent pool!
                    </p>
                    <p class="mt-0 text-sm md:m-7">
                      This candidate has been added as a possible match for the
                      role(s) you’re looking to fill and will be contacted to
                      confirm their interest. One of our Client Success team
                      members will coordinate with you and the VA to ensure a
                      successful match.
                    </p>
                    <div class="flex flex-col items-center">
                      <button
                        class="bg-vgteal mb-3 rounded-3xl px-8 py-2 text-sm font-bold text-white"
                        @click.stop="addCandidate(assistant)"
                      >
                        OK
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <div v-if="!user && checkoutStore.assistantsObj.count > 0">
                <h1 class="pb-10 text-4xl font-semibold">Hooray!</h1>
                <div
                  class="mx-auto my-5 max-w-4xl px-6 py-2"
                  :class="{
                    'rounded-2xl bg-white p-11 shadow-md': !uiStore.mobile,
                  }"
                >
                  <h1
                    v-if="checkoutStore.assistantsObj.count >= 0"
                    class="mt-0 text-center text-2xl font-semibold md:mb-8 md:text-left"
                  >
                    We found
                    <span class="text-vgorange"
                      >{{ checkoutStore.assistantsObj.count
                      }}<span v-if="checkoutStore.assistantsObj.count > 1"
                        >s
                      </span>
                    </span>
                    possible virtual assistant<span
                      v-if="checkoutStore.assistantsObj.count - 3 > 1"
                      >s</span
                    >
                    who match your needs:
                  </h1>
                  <div
                    class="grid grid-cols-2 content-center items-center justify-center gap-4 md:flex md:flex-row"
                    :class="{
                      'rounded-2xl bg-white p-5 shadow-md': uiStore.mobile,
                    }"
                  >
                    <p class="col-span-2 font-semibold">Candidate preview</p>
                    <div
                      v-for="(assistant, index) in assistants.slice(0, 3)"
                      :key="index"
                      class="grid-col card m-0 bg-white"
                    >
                      <v-hover v-slot="{ hover }">
                        <div
                          class="flex flex-col items-center justify-center rounded-md bg-white p-3 hover:shadow-lg"
                          @click="showAssistant(assistant)"
                        >
                          <img
                            class="relative z-20 inline h-24 w-24 rounded-full border-2 border-white object-cover"
                            :src="getAvatar(assistant)"
                            lazy-src="/img/profile.png"
                            alt="Profile image"
                          />

                          <button
                            class="pr-4"
                            :class="[
                              'text-sm font-semibold ',
                              hover ? 'text-vgorange' : 'text-vgmedturq',
                            ]"
                            @click="showAssistant(assistant)"
                          >
                            <v-icon
                              class="pb-1 pl-1"
                              size="small"
                              :color="hover ? vgOrange : vgDarkerTeal"
                              >mdi-magnify</v-icon
                            >preview
                          </button>
                        </div>
                      </v-hover>
                    </div>
                    <img
                      v-if="!uiStore.mobile"
                      src="/img/threeStars.png"
                      class="m-4 mx-auto"
                      style="max-width: 3rem"
                      alt
                    />
                    <div class="mt-6 md:max-w-[200px]">
                      <div class="grid-cols relative grid">
                        <img
                          class="block overflow-visible"
                          src="/img/more_matches_bg.png"
                        />
                        <div class="absolute left-16 top-14">
                          <p class="text-vgorange mb-0 text-4xl">
                            +{{ assistants.slice(3).length }}
                          </p>
                          <p
                            class="text-vgorange justify-center text-xs font-semibold uppercase"
                          >
                            more match<span
                              v-if="checkoutStore.assistantsObj.count > 4"
                              >es</span
                            >
                          </p>
                        </div>
                        <p
                          class="self-end text-center text-sm font-semibold md:max-w-[200px]"
                        >
                          Create an account to see your full candidate profiles
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="mx-auto my-0 w-56">
                  <p class="text-vgocean font-bold">
                    Ready to see your possible candidates?
                  </p>
                  <div class="flex flex-col gap-4">
                    <vg-btn @click="$router.push('/client/signup/')"
                      >GET STARTED</vg-btn
                    >
                    <button
                      class="text-vgocean font-semibold uppercase underline"
                      @click="goBack"
                    >
                      Back
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            v-else-if="user && checkoutStore.assistantsObj.count === 0"
            class="grid rounded-md bg-white text-left md:grid-cols-3"
          >
            <div class="m-7 md:col-span-2">
              <h1 class="mb-7 text-3xl font-semibold">Oops!</h1>
              <div
                v-if="
                  selectedRolesWithHours.length > 0 &&
                  selectedRolesCheckbox.length == 0
                "
              >
                <p class="mb-7 text-xl font-semibold">
                  Unable to show results without a role selected. Please select
                  one or more roles.
                </p>
              </div>
              <div v-else-if="selectedRolesWithHours.length === 0">
                <p class="mb-7 text-xl font-semibold">
                  Unable to show results without any roles. Please add more
                  roles.
                </p>
              </div>
              <div v-else>
                <p class="mb-7 text-xl font-semibold">
                  It looks like we can’t find candidates that match your search
                  criteria.
                </p>
                <ol
                  class="bg-vgteal-200 mt-7 list-disc rounded-2xl p-5 font-semibold"
                >
                  <li class="ml-5">
                    Try adjusting your search filters or reach out to one of our
                    Solutions consultants to talk through your needs.
                  </li>
                </ol>
              </div>
              <div class="mb-4 mt-7 flex gap-1">
                <v-icon :color="vgOrange" class="m-3" size="x-large"
                  >mdi-headphones-settings</v-icon
                >
                <p class="text-vgorange text-base font-semibold">
                  Our team is here to help you! If you’re running into too much
                  trouble, you can book a call with our team!
                </p>
              </div>
            </div>
            <div
              class="min-w-[160px]] card m-5 flex max-w-[230px] flex-auto flex-col items-center justify-self-center rounded-md bg-white p-4 shadow"
            >
              <div class="relative">
                <v-avatar size="112" class="mb-2">
                  <v-img
                    :src="specialVGUser.avatar"
                    lazy-src="/img/profile.png"
                  />
                  <template #placeholder>
                    <v-row fill-height align-center ma-0>
                      <v-progress-circular
                        indeterminate
                        color="grey-lighten-5"
                      ></v-progress-circular>
                    </v-row>
                  </template>
                </v-avatar>
              </div>
              <p class="name-cut mb-2 self-center text-base font-bold">
                {{ specialVGUser.display_name }}
              </p>

              <p class="cut text-vgocean my-2 h-[9] text-center text-sm">
                {{ specialVGUser.blurb }}
              </p>
              <div class="mt-2">
                <button
                  class="bg-vgocean rounded-3xl px-4 pb-2 pt-1 font-semibold text-white"
                  @click.stop="helpMeDecideModal = true"
                >
                  help me decide
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="assistants.length > 1 && user" class="mx-auto my-0 flex">
      <div v-if="!uiStore.mobile" class="w-96"></div>
      <v-pagination
        v-if="assistantsPageLength > 1"
        :model-value="checkoutStore.assistantsPage"
        class="border-vgocean w-full text-center"
        :length="assistantsPageLength"
        :color="vgOcean"
        density="comfortable"
        @update:model-value="paginationGoToInput"
      ></v-pagination>
    </div>
    <div class="justify-self-center">
      <div
        v-if="user"
        class="lg:box-top mx-auto my-0 mt-5 flex w-full flex-col-reverse gap-4 bg-white shadow-xl lg:flex-row lg:px-0"
      >
        <div v-if="uiStore.mobile" class="mx-4 mt-1 bg-white text-center">
          <h3 class="mb-1 mt-0 text-xl">We’re here to help!</h3>
          <p class="text-vgocean text-sm">
            Book a consult with our team and they will help you choose the best
            match for your needs!
          </p>
          <vg-btn
            v-if="user"
            class="rounded-lg px-10"
            @click="helpMeDecideModal = true"
            ><span class="px-5 text-sm">Help me decide</span></vg-btn
          >
        </div>
        <div
          :class="[
            'flex w-full flex-col-reverse justify-end  lg:flex-row  ',
            { 'bg-vgocean p-6 ': uiStore.mobile },
            { 'mx-auto my-1 mr-10 gap-4 bg-white md:px-0': !uiStore.mobile },
          ]"
        >
          <vg-btn v-if="!uiStore.mobile" @click="goBack"> Back </vg-btn>
          <button
            v-else
            class="pt-3 font-semibold uppercase text-white underline"
            @click="goBack"
          >
            Back
          </button>

          <div class="items-center uppercase">
            <vg-btn v-if="!uiStore.mobile" @click="goToCheckoutConfirmation">
              PROCEED TO CHECKOUT</vg-btn
            >
            <button
              v-else
              class="bg-vgteal-200 text-vgocean w-full rounded-xl p-2 px-5 text-sm font-semibold uppercase"
              @click="goToCheckoutConfirmation"
            >
              PROCEED TO CHECKOUT
            </button>
          </div>
        </div>
      </div>
    </div>

    <ClientVAList
      :va-list="vasAvailabilityCheckList"
      :va-list-modal="showVAsToLoseModal"
      @remove="removeVAsWithInsufficientHours"
      @revert="revertHours"
    >
      <template #title>
        <p>By Changing hours you will lose these VAs:</p>
      </template>
    </ClientVAList>
    <DeleteRoleDialog ref="deleteRoleDialog" />

    <v-dialog
      :model-value="checkoutStore.isInDialog"
      max-width="800px"
      persistent
      scrollable
    >
      <v-card class="!rounded-md">
        <div class="bg-white p-5">
          <div class="flex justify-end">
            <fa-icon
              icon="fa-regular fa-xmark-large"
              class="text-vgocean"
              @click="closeModal"
            />
          </div>
          <requirements-selector
            v-if="addRoleSteps[currentAddRoleIndex] === 'requirements'"
          />
          <Roles v-if="addRoleSteps[currentAddRoleIndex] === 'roles'" />
          <HoursSelector
            v-if="addRoleSteps[currentAddRoleIndex] === 'hours'"
            class="mb-7"
            :error="hoursError"
          />
          <div
            class="mx-auto my-0 mb-6 flex w-full max-w-4xl flex-col-reverse justify-end gap-4 px-6 md:flex-row md:px-0"
          >
            <vg-btn
              :class="{
                invisible: currentAddRoleIndex === 0,
              }"
              @click="goBackForAddRoleModal"
            >
              Back
            </vg-btn>

            <vg-btn
              v-if="currentAddRoleIndex !== addRoleSteps.length - 1"
              :disabled="currentAddRoleIndex === addRoleSteps.length - 1"
              @click="goNextForAddRoleModal"
            >
              Next
            </vg-btn>
            <vg-btn
              v-else
              :disabled="hoursNotSet"
              @click:disabled="showHoursError = true"
              @click="updateLocalStorage"
            >
              Done
            </vg-btn>
          </div>
        </div>
      </v-card>
    </v-dialog>

    <v-dialog v-model="helpMeDecideModal" max-width="800px" persistent>
      <div class="rounded-md bg-white p-5">
        <div class="flex justify-end">
          <fa-icon
            icon="fa-regular fa-xmark-large"
            class="text-vgocean"
            @click="helpMeDecideModal = false"
          />
        </div>
        <div
          class="flex grid-flow-row flex-col gap-5 md:mx-11 md:mb-11 md:grid md:grid-cols-2 md:gap-10"
        >
          <div class="col-span-2 text-center">
            <h1 class="mb-3 text-3xl font-bold">Help me decide</h1>
            <p class="text-xl font-semibold">What would you like to do?</p>
          </div>
          <div
            class="col-span-2 flex grid-flow-row flex-col gap-2 md:grid md:grid-cols-2"
          >
            <p class="text-left text-sm font-normal">
              Our Solutions team will help you define your needs.
            </p>

            <vg-btn @click="$router.push('/client/contact/')"
              >Book a call</vg-btn
            >
          </div>
          <p class="line col-span-2">
            <span>OR</span>
          </p>
          <div
            class="col-span-2 flex grid-flow-row flex-col gap-2 md:grid md:grid-cols-2"
          >
            <p class="text-left text-sm font-normal">
              After you check out, our Client Success team will contact you to
              finalize your matches.
            </p>
            <vg-btn class="uppercase" @click="goToCheckoutConfirmation"
              >PROCEED TO CHECKOUT</vg-btn
            >
          </div>
        </div>
      </div>
    </v-dialog>
  </div>
</template>

<script>
import { checkVAavailability } from '@/services/virtualAssistantsService';
import { API_URL, checkoutHoursItems } from '@/config';
import { mapStores, storeToRefs } from 'pinia';
import { useCheckoutStore } from '@/stores/checkout';
import { useClientDashboardStore } from '@/stores/clientDashboard';
import { useConfigStore } from '@/stores/config';
import { useUiStore } from '@/stores/ui';
import { useUserStore } from '@/stores/user';
import VaSearchFilters from '@/components/vaSearchFilters.vue';
import { getState } from '@/services/matchingService';
import ClientVAList from '@/components/ClientVAList.vue';
import DeleteRoleDialog from '@/components/serviceSelection/DeleteRoleDialog.vue';
import RequirementsSelector from '@/components/serviceSelection/RequirementsSelector.vue';
import Roles from '@/components/serviceSelection/Roles.vue';
import HoursSelector from '@/components/serviceSelection/HoursSelector.vue';
import tailwind from 'tailwind.config';
import HoursEditor from '@/components/serviceSelection/HoursEditor.vue';
import VaFilterMobileWrapper from '@/components/VaFilterMobileWrapper.vue';
import { sessionUserHasPermission } from '@/services/clientSessionService';
import { saveProject } from '@/services/projectService';
import FaIcon from '@/components/FaIcon.vue';

export default {
  name: 'SearchResult',
  components: {
    VaSearchFilters,
    ClientVAList,
    RequirementsSelector,
    Roles,
    HoursSelector,
    HoursEditor,
    VaFilterMobileWrapper,
    DeleteRoleDialog,
    FaIcon,
  },
  emits: ['goBack'],
  data() {
    const { user } = storeToRefs(useUserStore());
    const { checkFeatureFlag } = storeToRefs(useConfigStore());
    const { initClientProjects } = useClientDashboardStore();

    return {
      user,
      checkFeatureFlag,
      initClientProjects,
      loading: false,
      selectedAssistant: null,
      categories: [],
      selectedNeeds: [],
      mediaMatcher: null,
      originalRoles: [],
      originalHours: [],
      showVAsToLoseModal: false,
      vasAvailabilityCheckList: [],
      showHoursError: false,
      currentAddRoleIndex: 0,
      addRoleSteps: ['requirements', 'roles', 'hours'],
      checkoutHoursItems,
      vgOcean: tailwind.theme.extend.colors.vgocean[500],
      vgTeal: tailwind.theme.extend.colors.vgteal.DEFAULT,
      vgOrange: tailwind.theme.extend.colors.vgorange[500],
      helpMeDecideModal: false,
      specialVGUser: {
        uuid: -1,
        isSpecial: true,
        avatar: '/img/Virtual-Gurus-Assistants-Color-Logo-mobile.png',
        display_name: `Help me decide`,
        blurb: `Book a call with our Solutions team and they’ll help you find the best assistant(s) for your needs.
`,
      },
      editHours: false,
      showRemoveModalAtIndex: -1,
      showFirstTimeAddModalAtIndex: -1,
      threeColumns: true,
    };
  },
  computed: {
    ...mapStores(useUiStore, useCheckoutStore),
    assistants() {
      return this.checkoutStore.assistantsObj.assistants || [];
    },
    shouldCheckAll() {
      return (
        (this.checkoutStore.matchingCriteria?.rids &&
          this.checkoutStore.matchingCriteria?.rids.length ===
            this.selectedRolesCheckbox.length &&
          this.checkoutStore.matchingCriteria?.rids.length !== 0) ||
        false
      );
    },
    selectedRolesWithHours() {
      return this.checkoutStore.selectedRoles?.map((role) => {
        return {
          ...role,
          hours: this.checkoutStore.matchingCriteria.hours?.[
            this.getIndexOf(role.id)
          ],
          error: this.hoursError
            ? this.checkoutStore.matchingCriteria.hours?.[
                this.getIndexOf(role.id)
              ] === undefined ||
              this.checkoutStore.matchingCriteria.hours?.[
                this.getIndexOf(role.id)
              ] === null
              ? true
              : false
            : false,
        };
      });
    },
    assistantsPageLength() {
      return Math.ceil(
        this.assistants.length /
          this.checkoutStore.assistantPagination.assistantPerPage
      );
    },
    assistantsForPagination: function () {
      let modifiedAssistants = [...this.assistants];
      modifiedAssistants.splice(3, 0, this.specialVGUser);
      return modifiedAssistants.slice(
        (this.checkoutStore.assistantPagination.assistantsPage - 1) *
          this.checkoutStore.assistantPerPage,
        this.checkoutStore.assistantPagination.assistantsPage *
          this.checkoutStore.assistantPagination.assistantPerPage
      );
    },

    hoursNotSet() {
      return (
        this.checkoutStore.matchingCriteria?.rids?.length !==
        this.checkoutStore.matchingCriteria?.hours?.length
      );
    },
    hoursError() {
      return (
        this.addRoleSteps[this.currentAddRoleIndex] === 'hours' &&
        this.showHoursError === true
      );
    },
    selectedRolesCheckbox: {
      get() {
        return this.checkoutStore.matchingCriteria?.focusedRid
          ? this.checkoutStore.matchingCriteria?.focusedRid?.length !== 0
            ? this.checkoutStore.matchingCriteria.focusedRid
            : []
          : this.checkoutStore.matchingCriteria?.rids || [];
      },
      async set(val) {
        if (val.includes(-1)) {
          await this.checkoutStore.updateMatchingCriteria({
            ...this.checkoutStore.matchingCriteria,
            focusedRid: [],
          });
        } else {
          await this.checkoutStore.updateMatchingCriteria({
            ...this.checkoutStore.matchingCriteria,
            focusedRid: val,
          });
        }
        this.checkoutStore.updateAssistantPage(1);
      },
    },
    hours() {
      return this.checkoutStore.matchingCriteria.focusedRid
        ? this.checkoutStore.matchingCriteria.focusedRid.map((rid) => {
            return this.checkoutStore.matchingCriteria.hours[
              this.checkoutStore.matchingCriteria?.rids?.indexOf(rid)
            ];
          })
        : this.checkoutStore.matchingCriteria.hours;
    },
    totalHours() {
      if (
        this.hours?.find(
          (hoursItem) =>
            hoursItem ===
            this.checkoutHoursItems.find((item) => item.title === '100+').value
        )
      ) {
        return '100+';
      }
      if (
        this.checkoutStore.matchingCriteria?.focusedRid &&
        this.checkoutStore.matchingCriteria?.focusedRid.length !== 0
      ) {
        return this.hours.reduce((result, current) => {
          return result + parseInt(current);
        }, 0);
      } else {
        if (
          this.checkoutStore.matchingCriteria?.hours?.some((hour) => hour === 0)
        ) {
          return this.checkoutHoursItems[this.checkoutHoursItems.length - 1]
            .title;
        }
        return this.checkoutStore.matchingCriteria?.hours?.reduce(
          (result, current) => {
            return result + parseInt(current);
          },
          0
        );
      }
    },
    vaProfiles() {
      return this.user
        ? this.assistantsForPagination
        : this.assistants?.slice(0, 3);
    },
    showTwoLine() {
      return (index) => {
        if (this.checkoutStore.matchingCriteria.rids.length < 3) {
          return false;
        }

        let divider = this.threeColumns ? 3 : 2;
        let VasTCheck = this.vaProfiles.slice(
          Math.floor(index / divider) * divider,
          Math.floor(index / divider) * divider + divider
        );

        return !!VasTCheck.find(
          (vaProfile) =>
            vaProfile.roles
              ?.split(',')
              .filter((role) =>
                this.checkoutStore.selectedRoles.find(
                  (selectedRole) => role.trim() === selectedRole.value
                )
              ).length > 2
        );
      };
    },
  },
  watch: {
    'checkoutStore.matchingCriteria': {
      handler: function () {
        if (this.checkoutStore.matchingCriteria.rids) {
          this.searchVAs({ matchAnyRole: true });
        }
      },
      immediate: true,
    },
  },
  async created() {
    // 1280 is the media size for xl in tailwind configuration and
    //  breakpoint for showing 3 column vs 2 columns per row for VA cards
    this.mediaMatcher = window.matchMedia('(min-width: 1280px)');
    this.mediaMatcher.addEventListener('change', this.handleRolesHeight);
    this.handleRolesHeight(this.mediaMatcher);

    this.originalRoles = getState()?.query
      ? getState().query.rids
      : this.checkoutStore.matchingCriteria.rids;
    this.originalHours = getState()?.query
      ? getState()?.query.hours
      : this.checkoutStore.matchingCriteria.hours;
    if (
      this.checkoutStore.matchingCriteria?.rids?.length >
      this.checkoutStore.selectedRoles
    ) {
      await this.checkoutStore.loadCriteriaByIds(
        this.checkoutStore.matchingCriteria?.rids.join(',')
      );
    }
    this.uiStore.toggleVaFilterNavDrawerOpen(false);
  },
  unmounted() {
    this.mediaMatcher.removeEventListener('change', this.handleRolesHeight);
  },
  methods: {
    async selectAllRoles(val) {
      await this.checkoutStore.updateMatchingCriteria({
        ...this.checkoutStore.matchingCriteria,
        focusedRid: val ? [...this.checkoutStore.matchingCriteria.rids] : [],
      });
      this.checkoutStore.updateAssistantPage(1);
    },
    getAvatar(assistant) {
      if (assistant.avatar_id === -1) {
        return '/img/profile.png';
      }
      return `${API_URL}/file/avatar/${assistant.avatar_id}`;
    },
    showAssistant(assistant) {
      return this.$router
        .push(
          `/assistants/${assistant.uuid}?${'rids'}=${
            this.checkoutStore.matchingCriteria.focusedRid
              ? this.checkoutStore.matchingCriteria.focusedRid
              : this.checkoutStore.matchingCriteria.rids
          }${
            this.checkoutStore.matchingCriteria.hours
              ? '&hours=' + this.hours
              : ''
          }${
            this.checkoutStore.matchingCriteria.self_identifications
              ? '&self_identifications=' +
                this.checkoutStore.matchingCriteria.self_identifications
              : ''
          }${
            this.checkoutStore.matchingCriteria.availabilities
              ? '&availabilities=' +
                this.checkoutStore.matchingCriteria.availabilities
              : ''
          }${
            this.checkoutStore.matchingCriteria.timezone
              ? '&timezone=' + this.checkoutStore.matchingCriteria.timezone
              : ''
          }`
        )
        .catch(() => {});
    },

    searchVAs() {
      let filters = { ...this.checkoutStore.matchingCriteria };

      if (this.selectedRolesCheckbox.length === 0) {
        filters.rids = [];
      }
      filters.matchAnyRole = true;
      this.checkoutStore.searchVAs(filters);
    },

    goToCheckoutConfirmation() {
      if (
        this.hours.find(
          (hoursItem) =>
            hoursItem ===
            this.checkoutHoursItems.find((item) => item.title === '100+').value
        )
      ) {
        return this.$router.push('/client/contact/');
      }
      return this.immediateCheckout();
    },

    async revertHours() {
      //using data from cart to revert hours shown in query
      const ridsFromQuery = this.checkoutStore.matchingCriteria.rids;
      const hoursFromMatchingCriteria = this.checkoutStore.matchingCriteria
        .hours;

      this.checkoutStore.matchingCriteria.cart.forEach((va) => {
        hoursFromMatchingCriteria[ridsFromQuery.indexOf(va.role_id)] = va.hours;
      });

      await this.checkoutStore.updateMatchingCriteria({
        ...this.checkoutStore.matchingCriteria,
        hours: hoursFromMatchingCriteria,
      });

      this.showVAsToLoseModal = false;
    },
    async removeVAsWithInsufficientHours() {
      //update cart
      //1: remove vas that don't have enough hours
      //2: update the rest to have the selected new hours
      const ridsFromQuery = this.checkoutStore.matchingCriteria.rids;
      const hoursFromQuery = this.checkoutStore.matchingCriteria.hours;
      const newCart = this.checkoutStore.matchingCriteria.cart.reduce(
        (result, va) => {
          if (
            !this.vasAvailabilityCheckList.some(
              (vaToRemove) =>
                vaToRemove.role_id === va.role_id &&
                vaToRemove.assistant_id === va.assistant_id
            )
          ) {
            result.push({
              ...va,
              hours: hoursFromQuery[ridsFromQuery.indexOf(va.role_id)],
            });
          }
          return result;
        },
        []
      );
      await this.checkoutStore.updateMatchingCriteria({
        ...this.checkoutStore.matchingCriteria,
        cart: newCart,
      });

      this.showVAsToLoseModal = false;
    },
    async checkVAsInCartForNewHours() {
      if (!this.checkoutStore.matchingCriteria?.cart?.length) {
        return;
      }
      const newHours = this.checkoutStore.matchingCriteria.hours;
      const rids = this.checkoutStore.matchingCriteria.rids;

      //if a VA is selected for multiple roles add the greatest hours
      const selectedVas = this.checkoutStore.matchingCriteria.cart.reduce(
        (result, currentValue) => {
          result[currentValue.assistant_id] = result[currentValue.assistant_id]
            ? result[currentValue.assistant_id] >
              parseInt(newHours[rids.indexOf(currentValue.role_id)])
              ? result[currentValue.assistant_id]
              : parseInt(newHours[rids.indexOf(currentValue.role_id)])
            : parseInt(newHours[rids.indexOf(currentValue.role_id)]);
          return result;
        },
        {}
      );
      let vaAvailabilityList = [];
      Object.entries(selectedVas).forEach(([key, value]) => {
        vaAvailabilityList.push({ virtualAssistant_id: key, hours: value });
      });

      try {
        const result = await checkVAavailability(vaAvailabilityList).then(
          (response) => response.availability
        );

        this.vasAvailabilityCheckList = result
          .filter((VA) => VA.isAvailable === 0)
          .map((VA) => {
            const vaFromAvailabilityCheck = vaAvailabilityList.find(
              (va) => va.virtualAssistant_id === VA.uuid
            );
            return this.checkoutStore.matchingCriteria.cart.find(
              (va) =>
                va.assistant_id === VA.uuid &&
                va.role_id ===
                  rids[newHours.indexOf(vaFromAvailabilityCheck.hours)]
            );
          })
          .filter(Boolean);

        if (this.vasAvailabilityCheckList?.length > 0) {
          this.showVAsToLoseModal = true;
        } else {
          //update hours in cart
          let cartWithUpdatedHours = this.checkoutStore.matchingCriteria.cart.reduce(
            (result, currentValue) => {
              if (
                newHours[rids.indexOf(currentValue.role_id)] !==
                parseInt(currentValue.hours)
              ) {
                currentValue.hours =
                  newHours[rids.indexOf(currentValue.role_id)];
              }
              result.push(currentValue);
              return result;
            },
            []
          );
          await this.checkoutStore.updateMatchingCriteria({
            ...this.checkoutStore.matchingCriteria,
            cart: cartWithUpdatedHours,
          });
        }
      } catch (error) {
        this.revertHours();
        this.$root.$snackbar.error(
          error?.data?.message ?? 'Something happened please try again later.'
        );
      }
    },
    async goBack() {
      await this.checkoutStore.updateMatchingCriteria({
        ...this.checkoutStore.matchingCriteria,
        step: 'hours',
      });
      this.$emit('goBack');
    },
    goNextForAddRoleModal() {
      this.currentAddRoleIndex++;
    },
    goBackForAddRoleModal() {
      this.currentAddRoleIndex--;
    },
    async closeModal() {
      this.checkoutStore.setIsInModal(false);
      await this.checkoutStore.updateMatchingCriteria(getState().query);
      await this.checkoutStore.searchRoles();
      await this.checkoutStore.loadCriteriaByIds(getState().query.rids);
    },
    async updateLocalStorage() {
      this.checkoutStore.setIsInModal(false);
      await this.checkoutStore.updateMatchingCriteria(
        this.checkoutStore.matchingCriteria
      );
      await this.checkoutStore.searchRoles();
      await this.checkoutStore.loadCriteriaByIds(
        this.checkoutStore.matchingCriteria.rids
      );
    },
    async removeRole(role) {
      //check if role exists in the cart
      if (
        this.checkoutStore.matchingCriteria?.cart?.some(
          (cartItem) =>
            cartItem.assistant_id !== -1 &&
            parseInt(cartItem.role_id) === parseInt(role.id)
        ) &&
        this.checkoutStore.selectedRoles?.some(
          (selectedRole) => selectedRole.id === parseInt(role.id)
        )
      ) {
        this.$refs.deleteRoleDialog.open(role);
      } else {
        this.checkoutStore.toggleSelectedRoles(role);
        await this.checkoutStore.updateMatchingCriteria({
          ...this.checkoutStore.matchingCriteria,
          cart: this.checkoutStore.matchingCriteria.cart
            ? this.checkoutStore.matchingCriteria.cart.filter(
                (cartItem) => parseInt(cartItem.role_id) !== parseInt(role.id)
              )
            : [],
        });
      }
    },
    isVaProfileAddedToCart(assistant) {
      const rolesVaHas =
        assistant.role_ids?.split(',').map((id) => parseInt(id)) ?? [];

      return (
        this.selectedRolesCheckbox.length !== 0 &&
        this.selectedRolesCheckbox
          .filter((roleId) => rolesVaHas.includes(roleId))
          .every((roleId) =>
            this.checkoutStore.matchingCriteria?.cart?.find(
              (cartItem) =>
                cartItem.assistant_id === assistant.uuid &&
                cartItem.role_id === roleId
            )
          )
      );
    },
    async showOrRemoveAssistant(assistant) {
      if (this.isVaProfileAddedToCart(assistant)) {
        this.showRemoveModalAtIndex = -1;
        await this.checkoutStore.updateMatchingCriteria({
          ...this.checkoutStore.matchingCriteria,
          cart: this.checkoutStore.matchingCriteria.cart.filter(
            (va) =>
              !(
                va.assistant_id === assistant.uuid &&
                (this.checkoutStore.matchingCriteria.focusedRid &&
                this.checkoutStore.matchingCriteria.focusedRid.length !== 0
                  ? this.checkoutStore.matchingCriteria.focusedRid
                  : this.checkoutStore.matchingCriteria.rids
                ).includes(va.role_id)
              )
          ),
        });
      } else {
        this.showAssistant(assistant);
      }
    },

    async immediateCheckout() {
      await this.checkoutStore.immediateCheckout();
      this.$router.push('/client/checkout_confirmation').catch(() => {});
    },

    hoursChanged() {
      this.editHours = false;
      this.checkVAsInCartForNewHours();
    },
    toggleNavDrawer() {
      this.uiStore.toggleVaFilterNavDrawerOpen(
        !this.uiStore.vaFilterNavDrawerOpen
      );
    },
    paginationGoToInput(event) {
      this.checkoutStore.updateAssistantPage(event);
      if (!this.checkoutStore.matchingCriteria.confirmationShown) {
        this.showFirstTimeAddModalAtIndex = -1;
      }
      this.showRemoveModalAtIndex = -1;
    },
    getIndexOf(id) {
      return this.checkoutStore.matchingCriteria.rids.findIndex(
        (rid) => parseInt(rid) === id
      );
    },
    addCandidateOrShowFirstTimeModal(assistant, index) {
      if (!this.checkoutStore.matchingCriteria.confirmationShown) {
        this.showFirstTimeAddModalAtIndex = index;
      } else {
        this.addCandidate(assistant);
      }
    },
    async addCandidate(assistant) {
      this.showFirstTimeAddModalAtIndex = -1;
      const ridsToCheck =
        this.checkoutStore.matchingCriteria.focusedRid &&
        this.checkoutStore.matchingCriteria.focusedRid.length !== 0
          ? this.checkoutStore.matchingCriteria.focusedRid
          : this.checkoutStore.matchingCriteria.rids;
      const ridsToKeep =
        ridsToCheck.filter(
          (rid) =>
            !(this.checkoutStore.matchingCriteria?.cart || []).some(
              (va) => va.assistant_id === assistant.uuid && va.role_id === rid
            )
        ) || [];

      if (ridsToKeep.length === 0) {
        this.$root.$snackbar.message(`You have already selected this VA`);

        return;
      }

      this.showFirstTimeAddModalAtIndex = -1;

      const ridsAssistantHave = ridsToKeep.filter((rid) =>
        assistant.role_ids.includes(rid)
      );
      let newCart = [
        ...(this.checkoutStore.matchingCriteria.cart || []),
        ...ridsToKeep.map((role_id) => {
          return {
            hours: this.checkoutStore.matchingCriteria.hours[
              this.checkoutStore.matchingCriteria.rids.indexOf(role_id)
            ],
            role_id,
            assistant_id: ridsAssistantHave.includes(role_id)
              ? assistant.uuid
              : this.checkoutStore.specialVGUser.uuid,
            avatar_id: ridsAssistantHave.includes(role_id)
              ? assistant.avatar_id
              : this.checkoutStore.specialVGUser.avatar_id,
            known_as: ridsAssistantHave.includes(role_id)
              ? assistant.display_name
              : this.checkoutStore.specialVGUser.display_name,
            tids: this.checkoutStore.matchingCriteria.tids,
            sids: this.checkoutStore.matchingCriteria.sids,
            timezone: {
              timezone: this.checkoutStore.matchingCriteria.timezone,
              offset_range: this.checkoutStore.matchingCriteria.offset_range,
            },
            self_identifications: this.checkoutStore.matchingCriteria
              .self_identifications,
          };
        }),
      ];

      //filter out -1 candidate for ridsToKeep
      newCart = newCart.filter(
        (item) =>
          !ridsToKeep.find(
            (rid) => item.role_id === rid && item.assistant_id === -1
          )
      );
      if (!this.checkoutStore.matchingCriteria.confirmationShown) {
        await this.checkoutStore.updateMatchingCriteria({
          ...this.checkoutStore.matchingCriteria,
          confirmationShown: true,
        });
      } else {
        this.$root.$potentialMatchDialog.open(true);
      }

      await this.checkoutStore.updateMatchingCriteria({
        ...this.checkoutStore.matchingCriteria,
        cart: newCart,
      });

      if (sessionUserHasPermission('client')) {
        if (!this.checkoutStore.matchingCriteria.uuid) {
          const projectUUID = await saveProject().then(
            (response) => response.project_uuid
          );

          await this.checkoutStore.updateMatchingCriteria({
            ...this.checkoutStore.matchingCriteria,
            uuid: projectUUID,
          });

          await this.initClientProjects({ forceRefresh: true });
        }
      }
    },
    assistantFilteredRoles(assistant) {
      return assistant.roles
        ?.split(',')
        .filter((role) =>
          this.checkoutStore.selectedRoles.find(
            (selectedRole) => role.trim() === selectedRole.value
          )
        );
    },
    assistantFilteredSkills(assistant) {
      return (
        assistant.skills?.filter((skill) =>
          this.checkoutStore.selectedSkills
            .filter((skill) =>
              this.checkoutStore.matchingCriteria.sids.includes(skill.id)
            )
            .find((selectedSkill) => skill.trim() === selectedSkill.keyword)
        ) || []
      );
    },
    assistantFilteredTools(assistant) {
      return (
        assistant.tools?.filter((tool) =>
          this.checkoutStore.selectedTools
            .filter((tool) =>
              this.checkoutStore.matchingCriteria.tids.includes(tool.id)
            )
            .find((selectedTool) => tool.trim() === selectedTool.keyword)
        ) || []
      );
    },
    handleRolesHeight(mediaMatcher) {
      this.threeColumns = mediaMatcher.matches;
    },
  },
};
</script>

<style scoped>
.cut {
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 6;
  line-clamp: 6;
  -webkit-box-orient: vertical;
  display: -webkit-box;
  display: -moz-box;
}
.name-cut {
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 1;
  line-clamp: 1;
  -webkit-box-orient: vertical;
  display: -webkit-box;
  display: -moz-box;
}
.card:hover {
  transform: translateY(-5px) scale(1.005) translateZ(0);
}

* :deep(.v-pagination__item.v-pagination__item--active) {
  color: white;
}
* :deep(.v-pagination .v-pagination__item) {
  border-color: #035c67;
  border-style: solid;
  border-width: 1px;
  color: #035c67;
  background-color: white;
  padding: 0;
  border-radius: 5px;
}
.vg-truncate-chip :deep(.v-chip__content) {
  overflow: auto;
}

* :deep(.v-expansion-panel-text__wrapper) {
  padding: 0px;
}

.v-pagination__more {
  display: none;
}

.box-top {
  box-shadow: rgb(0 0 0 / 30%) 0px -6px 6px -6px;
  padding: 10px;
  margin-top: 10px;
}

.shadow {
  box-shadow: #86c6e520 0px 0px 10px 5px;
}

.line {
  width: 100%;
  text-align: center;
  border-bottom: 1px solid;
  @apply border-vgsilver-400;
  line-height: 0.1em;
  margin: 10px 0 20px;
}

.line span {
  background: #fff;
  padding: 0 10px;
}

.outline-icon {
  /* height: 28px; */
  @apply w-[30px];
  @apply h-[30px];
  @apply border-2;
  @apply border-solid;
  @apply border-vgteal-400;
}
</style>
